import { render, staticRenderFns } from "./choose-person.vue?vue&type=template&id=d20087ba&"
import script from "./choose-person.vue?vue&type=script&lang=js&"
export * from "./choose-person.vue?vue&type=script&lang=js&"
import style0 from "./choose-person.vue?vue&type=style&index=0&id=d20087ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports